import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {
  PaginaPublicacionDTO,
  PublicacionErpDTO,
  VentanaPublicacionDTO,
} from '../../services/workspace/DTO/publicacion-plataforma.dto';

const ZONA_ECUADOR = 'America/Guayaquil';

@Component({
  selector: 'app-novedades-modal',
  templateUrl: './novedades-modal.component.html',
  styleUrls: ['./novedades-modal.component.scss'],
})
export class NovedadesModalComponent {
  @Input() publicaciones: PublicacionErpDTO[] = [];

  indice = 0;
  pagina = 0;

  constructor(public activeModal: NgbActiveModal) {}

  get actual(): PublicacionErpDTO | null {
    return this.publicaciones[this.indice] || null;
  }

  get paginas(): PaginaPublicacionDTO[] {
    return this.actual?.paginas || [];
  }

  get paginaActual(): PaginaPublicacionDTO | null {
    return this.paginas[this.pagina] || null;
  }

  /** Total de pasos (paginas de todas las publicaciones; una sin paginas cuenta como uno). */
  get totalPasos(): number {
    return this.publicaciones.reduce((total, p) => total + Math.max(1, (p.paginas || []).length), 0);
  }

  get esPrimerPaso(): boolean {
    return this.indice === 0 && this.pagina === 0;
  }

  /** "Entendido" solo aparece al llegar a la ultima pagina de la ultima publicacion. */
  get esUltimoPaso(): boolean {
    return this.indice >= this.publicaciones.length - 1 && this.pagina >= this.paginas.length - 1;
  }

  /**
   * Avanza a la siguiente pagina; al terminar las paginas de una publicacion
   * pasa a la primera de la siguiente.
   */
  siguiente(): void {
    if (this.pagina < this.paginas.length - 1) {
      this.pagina += 1;
    } else if (this.indice < this.publicaciones.length - 1) {
      this.indice += 1;
      this.pagina = 0;
    }
  }

  /** Retrocede una pagina, o a la ultima pagina de la publicacion anterior. */
  anterior(): void {
    if (this.pagina > 0) {
      this.pagina -= 1;
    } else if (this.indice > 0) {
      this.indice -= 1;
      this.pagina = Math.max(0, this.paginas.length - 1);
    }
  }

  /** Salta a otra publicacion desde la navegacion lateral, en su primera pagina. */
  seleccionar(indice: number): void {
    this.indice = indice;
    this.pagina = 0;
  }

  /** Cierra confirmando la lectura: quien abrio el modal marca las vistas. */
  entendido(): void {
    this.activeModal.close('entendido');
  }

  /** Cierra sin terminar; las publicaciones no se marcan como vistas. */
  cerrar(): void {
    this.activeModal.dismiss('cerrar');
  }

  /** Fecha corta en hora de Ecuador, sin depender de la zona del navegador. */
  formatearFecha(fecha: string): string {
    if (!fecha) return '';
    return new Intl.DateTimeFormat('es-EC', {
      timeZone: ZONA_ECUADOR,
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(new Date(fecha));
  }

  /** Ventana de mantenimiento como "sáb, 24 oct · 22:00 a 23:30" en hora de Ecuador. */
  formatearVentana(ventana: VentanaPublicacionDTO): string {
    const dia = new Intl.DateTimeFormat('es-EC', {
      timeZone: ZONA_ECUADOR,
      weekday: 'short',
      day: '2-digit',
      month: 'short',
    }).format(new Date(ventana.fechaInicio));
    const hora = (fecha: string) => new Intl.DateTimeFormat('es-EC', {
      timeZone: ZONA_ECUADOR,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(new Date(fecha));
    return `${dia} · ${hora(ventana.fechaInicio)} a ${hora(ventana.fechaFin)}`;
  }
}
